module.exports = __webpack_public_path__ + "Flag-999.5357e7806a14bc3371232b1343134d71.svg";